export const MuiTabNode = {
  styleOverrides: {
    root: {},
  },
};
